module.exports = __webpack_public_path__ + "img/patrulla_caminera.3cde1585.png";